export class ActivateModalController {
  constructor($scope, $rootScope, $modalInstance, toastr, UserService, AuthService, socket) {
    $scope.vm = this;
    this.scope = $scope;
    this.rootScope = $rootScope;
    this.UserService = UserService;
    this.AuthService = AuthService;
    this.socket = socket;
    this.toastr = toastr;
    this.modalInstance = $modalInstance;
    this.scope.report = {};
  }

  activateProfile() {
    this.UserService.activateProfile(this.rootScope.currentUserProfile._id, true)
      .then((response) => { let result = response.data;
        if (result.success) {
          this.toastr.info('Profile has been activated');
          this.rootScope.getCurrentUser();
          this.socket.emit('toggleOnline', JSON.stringify({status: true}));
          this.modalInstance.close();
        }
        else {
          this.toastr.warning( result.message );
        }
      })
      .catch((response) => { let err = response.data;
        this.toastr.warning('Profile activation error');
      })
  };

  activateModalClose() {
    this.modalInstance.close();
    this.AuthService.logout();
  }
}
